module.exports = __webpack_public_path__ + "img/edit_bendi.f143385b.svg";